module.exports = __webpack_public_path__ + "static/media/stm-21st-desktop-2440x300-@2x.042cefc9.png";